/**
 * Allows only one active asynchronous function to be running at any given time.
 * Usage: gate.wait(yourAsyncFunction)
 */
export class Gate {
	gatePromises: {
		gatePromise: Promise<void>;
		func: () => Promise<void>;
		resolve: ((value: void | PromiseLike<void>) => void) | null;
	}[] = [];

	private async runOldest() {
		const entry = this.gatePromises[this.gatePromises.length - 1];
		await entry.func();
		this.gatePromises = this.gatePromises.filter((x) => x !== entry);
		entry.resolve?.();
		if (this.gatePromises.length) {
			this.runOldest();
		}
	}

	public async wait(func: () => Promise<void>) {
		const entry: any = {
			func,
		};
		entry.gatePromise = new Promise<void>((resolve) => {
			entry.resolve = resolve;
		});

		this.gatePromises = this.gatePromises.concat(entry);
		if (this.gatePromises.length === 1) {
			this.runOldest();
		}
		return entry.gatePromise;
	}
}
